// What the assistant panel says while one of this module's tools is running
// («Buscando entre las máquinas…»), in the four languages.
//
// A contract with `backend/assistant.js`, like the analytics vocabulary is with
// `backend/analytics.js`: every tool registered there gets the key
// `assistant.tools.<registered name>` — the name the platform gives it, with the
// module in front — and this file holds that key. The English here is the
// same sentence as the tool's `label`, which is what the panel shows when a
// key is missing. platform/web/tests/assistantToolLabels.test.js checks both:
// a tool without its four sentences, or an English one that drifted from the
// backend label, fails the suite.

const toolLabels = {
  es: {
    assets_find_assets: 'Buscando entre las máquinas',
    assets_asset_file: 'Abriendo la ficha de la máquina',
    assets_asset_history: 'Leyendo lo que se le ha hecho',
    assets_asset_reliability: 'Calculando los indicadores',
    assets_log_meter_reading: 'Apuntando una lectura del contador',
  },
  ca: {
    assets_find_assets: 'Cercant entre les màquines',
    assets_asset_file: 'Obrint la fitxa de la màquina',
    assets_asset_history: 'Llegint el que se li ha fet',
    assets_asset_reliability: 'Calculant els indicadors',
    assets_log_meter_reading: 'Anotant una lectura del comptador',
  },
  en: {
    assets_find_assets: 'Looking through the machines',
    assets_asset_file: 'Opening a machine sheet',
    assets_asset_history: 'Reading what has been done to it',
    assets_asset_reliability: 'Working out the indicators',
    assets_log_meter_reading: 'Filing a meter reading',
  },
  fr: {
    assets_find_assets: 'Recherche parmi les machines',
    assets_asset_file: 'Ouverture de la fiche de la machine',
    assets_asset_history: 'Lecture de ce qui lui a été fait',
    assets_asset_reliability: 'Calcul des indicateurs',
    assets_log_meter_reading: 'Enregistrement d’un relevé de compteur',
  },
}

/** The module's catalogue with its tool labels hung from `assistant.tools`, locale by locale. */
export function withToolLabels(base) {
  const merged = {}
  for (const [locale, catalogue] of Object.entries(base)) {
    merged[locale] = {
      ...catalogue,
      assistant: {
        ...catalogue.assistant,
        tools: { ...catalogue.assistant?.tools, ...toolLabels[locale] },
      },
    }
  }
  return merged
}

export default toolLabels
